export const it = {
  // Navigation
  nav: {
    home: "Home",
    gallery: "Galleria",
    landscapes: "Paesaggi",
    portraits: "Ritratti",
    abstract: "Astratto",
    about: "Chi Sono",
    contact: "Contatti",
    shop: "Negozio",
    shopAll: "Shop all",
    print: "Print",
    original: "Original",
    cart: "Carrello",
    admin: "Admin",
    myOrders: "I Miei Ordini",
    login: "Accedi",
    logout: "Esci",
    account: "Account",
  },

  // Home page
  home: {
    heroTitle: "Arte che racconta storie",
    heroSubtitle: "Arte per spazi vissuti.",
    heroCta: "Shop all",
    categoriesTitle: "Shop",
    categoriesSubtitle: "Esplora per categoria",
    featuredTitle: "Opere in Evidenza",
    featuredSubtitle: "Selezionate per te",
    viewAll: "Vedi Tutte",
    aboutTitle: "L'Artista",
    aboutText: "Ogni pennellata racconta una storia. Scopri il mondo di Dalila Di Maria attraverso le sue opere originali.",
    aboutCta: "Scopri di più",
  },

  // Categories
  categories: {
    print: "Print",
    printDesc: "Stampe d'arte per ogni spazio",
    original: "Original",
    originalDesc: "Opere uniche dipinte a mano",
    landscapes: "Paesaggi",
    landscapesDesc: "La bellezza della natura catturata su tela",
    portraits: "Ritratti",
    portraitsDesc: "L'anima delle persone attraverso il colore",
    abstract: "Astratto",
    abstractDesc: "Emozioni e forme oltre la realtà",
  },

  // Product/Artwork
  artwork: {
    price: "Prezzo",
    technique: "Tecnica",
    dimensions: "Dimensioni",
    year: "Anno",
    category: "Categoria",
    available: "Disponibile",
    sold: "Venduto",
    reserved: "Riservato",
    addToCart: "Acquista",
    buyNow: "Acquista Ora",
    inquire: "Richiedi Informazioni",
    relatedWorks: "Opere Correlate",
    details: "Dettagli",
    shipping: "Spedizione",
    shippingInfo: "Spedizione assicurata in tutto il mondo. L'opera viene imballata con cura professionale.",
  },

  // Cart & Checkout
  cart: {
    title: "Il Tuo Carrello",
    empty: "Il carrello è vuoto",
    continueShopping: "Continua a Esplorare",
    subtotal: "Subtotale",
    shipping: "Spedizione",
    total: "Totale",
    checkout: "Procedi al Pagamento",
    remove: "Rimuovi",
  },

  // Checkout
  checkout: {
    title: "Pagamento",
    customerInfo: "Informazioni di Contatto",
    name: "Nome Completo",
    email: "Email",
    phone: "Telefono",
    shippingAddress: "Indirizzo di Spedizione",
    address: "Indirizzo",
    city: "Città",
    postalCode: "CAP",
    country: "Paese",
    notes: "Note (opzionale)",
    pay: "Paga Ora",
    processing: "Elaborazione...",
    secure: "Pagamento sicuro con Stripe",
  },

  // Contact
  contact: {
    title: "Contattami",
    subtitle: "Hai domande su un'opera o vuoi commissionare un lavoro personalizzato?",
    name: "Nome",
    email: "Email",
    subject: "Oggetto",
    message: "Messaggio",
    send: "Invia Messaggio",
    success: "Messaggio inviato con successo! Ti risponderò presto.",
    error: "Errore nell'invio del messaggio. Riprova.",
  },

  // About
  about: {
    title: "Chi Sono",
    subtitle: "Dalila Di Maria",
    bio: "Sono un'artista italiana appassionata di pittura. Ogni mia opera nasce da un'emozione, un ricordo o un paesaggio che mi ha colpito. Lavoro principalmente con olio e acrilico su tela, cercando di catturare la luce e le atmosfere che rendono ogni momento unico.",
    studioTitle: "Il Mio Studio",
    processTitle: "Il Mio Processo Creativo",
    commissionsTitle: "Commissioni",
    commissionsText: "Accetto commissioni per opere personalizzate. Contattami per discutere la tua idea.",
    commissionsCta: "Richiedi una Commissione",
  },

  // Auth
  auth: {
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    confirmPassword: "Conferma Password",
    forgotPassword: "Password dimenticata?",
    loginWithGoogle: "Accedi con Google",
    loginWithEmail: "Accedi con Email",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    createAccount: "Crea Account",
    collectorSignIn: "Accesso collezionista",
    createCollectorAccount: "Crea un account collezionista",
    accountDescription: "Usa il tuo account per salvare i dati di pagamento e gestire gli ordini dello studio Dalila.",
  },

  // Account
  account: {
    title: "Il Mio Account",
    subtitle: "Gestisci il tuo profilo e visualizza i tuoi ordini dallo studio Dalila.",
    welcome: "Benvenuto",
    roleUser: "Collezionista",
    roleAdmin: "Amministratore",
    profile: "Profilo",
    name: "Nome",
    email: "Email",
    orders: "I Miei Ordini",
    ordersEmpty: "Non hai ancora ordini.",
    orderNumber: "Ordine n.",
    adminPanel: "Pannello Admin",
    logout: "Esci",
  },

  // Footer
  footer: {
    rights: "Tutti i diritti riservati",
    privacy: "Privacy",
    terms: "Termini e Condizioni",
    followMe: "Seguimi",
    newsletter: "Newsletter",
    newsletterText: "Iscriviti per ricevere aggiornamenti sulle nuove opere",
    subscribe: "Iscriviti",
    emailPlaceholder: "La tua email",
  },

  // Common
  common: {
    loading: "Caricamento...",
    error: "Si è verificato un errore",
    retry: "Riprova",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    close: "Chiudi",
    search: "Cerca",
    filter: "Filtra",
    sortBy: "Ordina per",
    noResults: "Nessun risultato",
    viewMore: "Vedi di più",
    backToHome: "Torna alla Home",
  },

  // Order confirmation
  orderConfirmation: {
    title: "Ordine Confermato!",
    subtitle: "Grazie per il tuo acquisto",
    orderNumber: "Numero Ordine",
    emailSent: "Ti abbiamo inviato una conferma via email.",
    continueShopping: "Continua a Esplorare",
  },
} as const;

export type Translations = typeof it;
